import React, { Component } from 'react';
import ClientCard from './ClientCard'

export default class ClientColumn extends React.Component {
	constructor(props) {
		super(props);
		this.state = ({ mouseIsHovering: false });
	}

	componentWillReceiveProps(nextProps) {
        this.setState({ mouseIsHovering: false });
	}

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    generateKanbanCards() {
        return this.props.works.slice(0).sort(this.sort).map((work, index) => {
            return (
                <ClientCard
                    work={work}
                    key={work.id}
                    onTimeChange={this.props.onTimeChange}
                    onDragEnd={this.props.onDragEnd}
                    onWorkUpdate={this.props.onWorkUpdate}
                    onCardOpen={this.props.onCardOpen}
                    onDragPositionChange={this.props.onDragPositionChange}
                    onCtrlCardClick={this.props.onCtrlCardClick}
                />)
            }
		);
	}

	render() {
        return (
           <div className="droppable-column">
                    <div>
                        <div className="kanban-column">
                            <div className="clearfix"><div className={"column-title "  + this.props.id}>{this.props.name}</div><div className="column-counter">{this.props.works && this.props.works.length}</div></div>
                            {this.generateKanbanCards()}
                        </div>
                    </div>
                </div>
        );
    }
}